export default "__VITE_ASSET__BRWifD9b__"